export default __webpack_public_path__ + "static/media/chaithanya.5cce85c6.png";